module.exports = __webpack_public_path__ + "img/hero-img.e6eee678.svg";